var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.861 1.03C16.245.298 15.109 0 12.939 0H5.06C2.84 0 1.685.318 1.072 1.097c-.598.76-.598 1.878-.598 3.427v2.952c0 3 .71 4.524 4.587 4.524h7.878c1.882 0 2.925-.263 3.6-.91.691-.661.987-1.742.987-3.614V4.524c0-1.633-.047-2.759-.665-3.494Zm-5.44 5.378-3.577 1.87a.55.55 0 0 1-.805-.488V4.062a.55.55 0 0 1 .804-.488l3.577 1.858a.55.55 0 0 1 .001.976Z",
    fill: "#002FF1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/play-icon.cee511e10715c9d420de9cdbf65037ae.svg";
export { ForwardRef as ReactComponent };